export async function floorPlanLoader({ user, selectedCompany, selections, url }) {

  const staircaseType = selections.find(
    (selection) => selection.item_type === "staircase_type"
  );

  const staircaseTypeId = staircaseType?.staircase_type_id || selectedCompany?.staircase_type_id;

  if (!staircaseTypeId) {
    return { options: {}, selectedOptions: { byCategory: {}, all: [] } };
  }

  const res = await fetch(
    `${url}/form/floor-plans?staircase_type_id=${staircaseTypeId}`,
    { headers: { Authorization: `Bearer ${user.token}` } }
  );

  const floorPlans = await res.json();

  const formatted = floorPlans.map(fp => ({
    id: fp.id,
    selectable_item_id: fp.selectable_item_id,
    name: fp.name,
    description: fp.description,
    image: fp.image || null,
    isFloorPlan: true,
    category_name: fp.category_name
  }));

  const optionsBySubcategory = {};

  formatted.forEach(fp => {
    if (!optionsBySubcategory[fp.category_name]) {
      optionsBySubcategory[fp.category_name] = [];
    }
    optionsBySubcategory[fp.category_name].push(fp);
  });

  const selectedMap = { byCategory: {}, all: [] };

  selections.forEach(sel => {
    const key = sel.category_name;
    if (!key) return;

    if (sel.item_type === "floor_plan") {
      selectedMap.byCategory[key] = sel.floor_plan_id;
      selectedMap.all.push(sel.floor_plan_id);

    } else if (sel.item_type === "option") {
      selectedMap.byCategory[key] = sel.option_id;
      selectedMap.all.push(sel.option_id);

    } else if (sel.item_type === "product") {
      selectedMap.byCategory[key] = sel.product_id;
      selectedMap.all.push(sel.product_id);
    }
  });

  return {
    options: optionsBySubcategory,
    selectedOptions: selectedMap
  };
}